import { ClaimFilingStep } from '@/components/claims-filing/hooks/useClaimFilingState';

/**
 * Build the canonical Claims Filing URL for a given matter/coverage and step.
 * Only the `step` query param is included; other params are intentionally
 * omitted to keep navigation simple and predictable.
 */
export const buildClaimsFilingUrl = (
  matterId: string,
  coverageId: string,
  step: ClaimFilingStep,
): string =>
  `/matters/${matterId}/coverage/${coverageId}/claims-review?step=${step}`;

export const resolvePremisesLorStep = ({
  lorDone,
}: {
  lorDone: boolean;
  reviewSendDone: boolean;
}): ClaimFilingStep => {
  return lorDone ? 'review_send' : 'lor';
};

/**
 * Build the coverage overview URL for a matter/coverage pair.
 */
export const buildCoverageOverviewUrl = (
  matterId: string,
  coverageId: string,
): string => `/matters/${matterId}/coverage/${coverageId}`;

export type CoverageEditTab =
  | 'basic'
  | 'contacts'
  | 'policy'
  | 'benefits'
  | 'claims';

export const buildCoverageEditUrl = (
  matterId: string,
  coverageId: string,
  tab?: CoverageEditTab,
): string => {
  const baseUrl = `/matters/${matterId}/coverage/${coverageId}/edit`;
  if (!tab) {
    return baseUrl;
  }
  return `${baseUrl}?tab=${tab}`;
};
